import { MessageProps } from "./interface";

export default function Table ({
  assistantMessageObj,
}: {
  assistantMessageObj: MessageProps;
}){
  return (
    <div>
      <br />
      <table className="table">
        <thead>
          <tr>
            {assistantMessageObj?.data?.columns?.map(
              (item: string, index: number) => {
                return (
                  <th key={index} className="text-black">
                    {item}
                  </th>
                );
              }
            )}
          </tr>
        </thead>
        <tbody>
          {assistantMessageObj?.data?.data?.map((item: any, index: number) => {
            if (item)
              return (
                <tr key={index}>
                  {assistantMessageObj.data.columns?.map(
                    (col: string, index: number) => {
                      return <td key={index}>{item[col]}</td>;
                    }
                  )}
                </tr>
              );
          })}
        </tbody>
      </table>
    </div>
  );
};
